import { Link as GatsbyLink } from 'gatsby';
import React, { ForwardedRef, forwardRef } from 'react';

import type { GatsbyLinkProps } from 'gatsby';

type LinkProps<State> = GatsbyLinkProps<State>;

const LinkInner = function <LinkState>(
  props: LinkProps<LinkState>,
  ref: ForwardedRef<any>
) {
  return <GatsbyLink {...props} ref={ref} />;
};

const Link = forwardRef(LinkInner);

Link.displayName = 'Link';

export default Link;
